export const filterMenu = (items, hiddenRoutes = []) => {
  return items
    .map((item) => {
      const filteredItem = { ...item };

      if (filteredItem.categories) {
        filteredItem.categories = filterMenu(filteredItem.categories, hiddenRoutes);
      }

      if (filteredItem.children) {
        filteredItem.children = filterMenu(filteredItem.children, hiddenRoutes);
      }

      return filteredItem;
    })
    .filter((item) => {
      if (item.route && hiddenRoutes.includes(item.route)) {
        return false;
      }

      if (item.categories && !item.categories.length) {
        return false;
      }

      if (item.children && !item.children.length) {
        return false;
      }

      return true;
    });
};
